export function TextDirection(language) {
    switch(language){
        case 'ko-kr': // 한국어
        case 'en-us': // 영어 (미국)
        case 'zh-cn': // 중국어 (간체)
        case 'ja-jp': // 일본어
        case 'zh-tw': // 대만 (번체)
        case 'vi-vn': // 베트남어
            return 'ltr';

        default:
            return 'ltr';
    }
}

export function supportLanguage(language){
    const languages = ['ko-kr', 'en-us', 'zh-cn', 'vi-vn', 'ja-jp', 'zh-tw'];

    return languages.some((p) => p === language);
}

// 배열 합치기
export function ArrayConcat(array, value) {
    const newArray = array;
    const index = newArray.indexOf(value);

    if (index > -1) {
        newArray.splice(index, 1);
    }
    else {
        newArray.push(value);
    }

    return newArray;
}

// 천단위 콤마 추가
export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// 숫자 앞에 문자열 추가
export function PadStart(number, length, string) {
    return number.toString().padStart(length, string);
}

// 통화 기호 콤마
export function NumberWithCurrency(locale,currency) {
    return Intl.NumberFormat(locale, { style: 'currency', currency: currency });
}

// 기간제 아이템 일 변환
export function TimeToDay(time) {
    return time / (60 * 24);
}

export function ImportScript(id, url) {
    const script = window.document.createElement('script');
    script.id = id;
    script.src = url;

    window.document.head.appendChild(script);
}

export const RemoveElementById = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
        document.head.removeChild(element);
    }
};